<template>
  <div class="comContent">
    <div class="header">
      <el-form
        ref="searchTool"
        :inline="true"
        style="text-align: left"
        v-model="searchData"
      >
        <el-form-item prop="name">
          <el-input
            v-model="searchData.shopName"
            placeholder="请输入店铺信息"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item prop="name">
          <el-input
            v-model="searchData.labelName"
            placeholder="请输入标签名称"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item prop="name">
          <el-select
            v-model="searchData.checkStatus"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>
        <el-form-item> </el-form-item>
      </el-form>
    </div>
    <div class="center">
      <myTable
        :index="false"
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="loading"
        :table-data="tableData"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
      >
        <template slot="shopName" slot-scope="scope">
          <div>{{ scope.row.shopName }}</div>
        </template>
        <template slot="concatName" slot-scope="scope">
          <div>
            {{ showConcatInfo(scope.$index) }}
          </div>
        </template>
        <template slot="labelName" slot-scope="scope">
          <div>{{ scope.row.labelName }}</div>
        </template>
        <template slot="image" slot-scope="scope">
          <div class="table-cell-pic-wrap" v-if="scope.row.image">
            <el-image
              :ref="`ref${scope.$index}`"
              :src="scope.row.image"
              class="table-cell-pic"
              :initial-index="0"
              :preview-src-list="[scope.row.image]"
            />
            <div class="preview">
              <el-image
                :src="SeeIcon"
                class="btn-icon"
                @click="handlePreview(`ref${scope.$index}`)"
              />
            </div>
          </div>
        </template>
        <template slot="updateTime" slot-scope="scope">
          <div>{{ scope.row.updateTime }}</div>
        </template>
        <template slot="checkStatus" slot-scope="scope">
          <div>{{ showState(scope.$index) }}</div>
        </template>
        <template slot="remark" slot-scope="scope">
          <div>{{ scope.row.remark }}</div>
        </template>
        <template slot="operation" slot-scope="scope">
          <div style="margin: 0 0px" v-if="scope.row.checkStatus == 1">
            <el-link
              type="primary"
              :underline="false"
              @click="handleCheckOk(scope.$index)"
              style="margin-right: 10px"
            >
              审核通过
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click="handleCheckFail(scope.$index)"
              style="margin-right: 10px"
            >
              驳回
            </el-link>
          </div>
        </template>
      </myTable>
    </div>

    <ReasonDlgView ref="refReasonDlgView" @updateSuccess="getList" />
  </div>
</template>

<script>
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import myTable from "@/components/myTable";
import { getLabelInfo, checkLabelInfo } from "@/api/platform/index";
import ReasonDlgView from "./dialog/reasonDlg.vue";

export default {
  components: { myTable, ReasonDlgView },
  data() {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      searchData: {
        shopName: "", //店铺信息
        labelName: "", //标签名称
        checkStatus: "",
      },
      tableData: [],
      statusList: [
        { value: 0, label: "驳回" },
        { value: 1, label: "待审核" },
        { value: 2, label: "审核通过" },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      loading: false,
      tableOption: [
        { label: "店铺信息", prop: "shopName", width: 140 },
        {
          label: "运营人员&联系方式",
          prop: "concatName",
          width: 260,
          slot: true,
        },
        { label: "标签名称", prop: "labelName", width: 140 },
        { label: "图层", prop: "image", width: 100, slot: true },
        { label: "编辑时间", prop: "updateTime" },
        { label: "审核状态", prop: "checkStatus", slot: true },
        {
          label: "备注",
          prop: "remark", //资质状态名称(0.正常 ， 1.过期)
          width: 120,
          slot: true,
        },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 120,
          // fixed: "right",
        },
      ],
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    reset() {
      this.searchData.shopName = "";
      this.searchData.labelName = "";
      this.searchData.checkStatus = "";
    },
    showConcatInfo(index) {
      const item = this.tableData[index];
      let info = item.concatName ? item.concatName : "";
      if (info && item.concatPhone) {
        info += "&&" + item.concatPhone;
      }
      return info;
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].showViewer = true;
      }
    },
    handleCheckFail(index) {
      const item = this.tableData[index];
      this.$refs.refReasonDlgView.open(item);
    },
    handleCheckOk(index) {
      const item = this.tableData[index];
      const data = {
        id: item.id,
        checkStatus: 2,
      };

      checkLabelInfo(data).then((res) => {
        if (res) {
          this.getList();
        }
      });
    },
    showState(index) {
      //"审核状态0-驳回 1-待审核 2-审核通过"
      const checkStatusDesp = ["驳回", "待审核", "审核通过"];
      const item = this.tableData[index];
      let i = +item.checkStatus;
      if (i >= 0 && i <= 2) {
        return checkStatusDesp[i];
      }
      return "";
    },
    handleSearch() {
      this.getList(1);
    },
    getList(current) {
      const params = Object.assign({}, this.searchData ? this.searchData : {});
      params.size = this.page.size;
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      getLabelInfo(params).then((data) => {
        if (data) {
          this.tableData = data.records;
          this.page.total = data.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comContent {
  padding: 0;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 10px 24px;
  height: calc(100% - 126px);
}

.table-cell-pic-wrap {
  width: 32px;
  height: 32px;
  position: relative;

  .table-cell-pic {
    width: 100%;
    height: 100%;
  }

  .preview {
    position: absolute;
    visibility: hidden;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .btn-icon {
      width: 16px;
      height: 16px;
      cursor: pointer;
      & + .btn-icon {
        margin-top: 0px;
      }
    }
  }

  &:hover {
    .preview {
      visibility: visible;
    }
  }
}
</style>
